import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Para qué edad de niños funciona el método?',
  a: 'El método O.P.S. está diseñado para niños de 3 a 10 años, que es la etapa donde se forman los hábitos espirituales más duraderos.'
}, {
  q: '¿Cuándo voy a recibir mi pack?',
  a: 'Inmediatamente después del pago recibirás un correo con el link de descarga. En menos de 2 minutos ya lo tendrás en tu celular.'
}, {
  q: '¿Necesito ser muy religiosa para usarlo?',
  a: 'Para nada. La guía está escrita en lenguaje simple y cercano, pensada para familias que quieren acercarse a Dios sin tecnicismos ni presión.'
}, {
  q: '¿Funciona si mi hijo es muy inquieto?',
  a: 'Sí. Por eso incluimos los dibujos para colorear. El acto de pintar calma el sistema nervioso del niño y le permite concentrarse en la oración mientras sus manos están ocupadas.'
}, {
  q: '¿Cómo funciona la garantía?',
  a: 'Tienes 7 días completos para usar el pack. Si no ves resultados, escríbenos y te devolvemos el 100% de tu dinero sin preguntas.'
}, {
  q: '¿En qué formato viene el producto?',
  a: 'Es un PDF descargable que puedes leer desde tu celular, tablet o computador e imprimir las veces que necesites.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 px-6 bg-cream" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <h2 className="font-fredoka text-3xl md:text-5xl text-charcoal text-center mb-12" data-id="element-31">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-32">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl shadow-sm border border-orange-50 overflow-hidden" data-id="element-33">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-34">
                <span className="text-lg font-bold text-charcoal pr-4" data-id="element-35">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-sage-green transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-36" />
              </button>

              <AnimatePresence data-id="element-37">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-38">
                    <div className="px-6 pb-5 text-gray-600 text-lg" data-id="element-39">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}